import './new-quote-activity.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormQuoteActivity from "../form-quote-activity/form-quote-activity";
import { useNewQuoteActivity } from './new-quote-activity.hook';

export function NewQuoteActivity() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewQuoteActivity();

  return (
    <div id="NewQuoteActivity" className="quote-activity">
      <HeaderContent
        title={<h1>New Quote Activity</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormQuoteActivity />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewQuoteActivity;